import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';

export const comingBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'applications',
    url: '/applications/outgoing'
  },
  {
    label: 'incoming',
    active: true
  }
];

export type Coming = {
  orders: string;
  recipient: string;
  currency: string;
  status: string;
  create_date: string;
  guid: string;
  can_update: boolean;
  maturity_date: string;
  date_auto_cancel: string;
  recipient_id: string;
  gupid: number;
  sender_id: string;
};
